$(document).ready(function () {
    initDashboard();
});

function initDashboard() {
    let block = $('[data-dashboard]');
    if (block.length === 0) {
        return;
    }

    initDevicesStatus();
    initPlacedStatus();
    initReservedStatus();

    initNetworkStatus();
    initNetworkTop();

    initOrdersChart();
    initOrdersStats();
    initOrdersPie();

    initTopDevices();

    initTopReport();

    initDevicesOrdersPlacedChart();
}

function initDevicesStatus() {
    let block = $('[data-dashboard="devices-status"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/online-offline/stat/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        setStatusData(
            block,
            response.data.total_devices_online,
            null,
            response.data.total_devices_sleep,
            response.data.total_devices,
            response.data.devices_online_ratio
        );
    });
}

function initPlacedStatus() {
    let block = $('[data-dashboard="placed-status"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/current/load/stat/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        setStatusData(
            block,
            response.data.total_placed,
            response.data.total_free,
            0,
            response.data.total_cells,
            response.data.ratio
        );
    });
}

function initReservedStatus() {
    let block = $('[data-dashboard="reserved-status"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/total/reserved/stat/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        setStatusData(
            block,
            response.data.total_reserved,
            response.data.total_free,
            0,
            response.data.total_cells,
            response.data.ratio
        );
    });
}

function initNetworkStatus() {
    let block = $('[data-dashboard="network-status"]');
    if (block.length === 0) {
        return;
    }

    let url = '/api/2.0.0/dashboard/devices/network/stat/';
    sendApiGet(url, function (response) {
        $('[data-total]', block).text(response.data.total);
        $('[data-mounted]', block).text(response.data.mounted);
    });
}

function initNetworkTop() {
    let block = $('[data-dashboard="network-device-top"]');
    if (block.length === 0) {
        return;
    }

    let url = '/api/2.0.0/dashboard/devices/network/top/';
    sendApiGet(url, function (response) {
        let data = response.data;
        $('[data-id]', block).text(data.device);
        $('[data-cells]', block).text(data.cells_count);
        $('[data-processed]', block).text(data.processed_count);
        $('[data-load]', block).text(data.load_percentage);
    });
}

function initOrdersChart(period= null) {
    let block = $('[data-dashboard="orders-chart"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/orders/period/stat/';
    url += (period === null) ? '?' : '?period=' + period
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '&net=' + dashboardNetworkFilter;
    }
    let timezone = "UTC";
    sendApiGet(url, function (response) {
        let series_reserved = [];
        let series_placed = [];
        let series_receipt = [];
        let series_prepared = [];
        let series_extracted = [];
        let series_canceled = [];
        let series_processed = [];
        let series_calls = [];

        let series = [];
        if (block.attr('data-franchisee')) {
            response.data.forEach(function (data, index, array) {
                let date = Date.parse(data.date);
                if (index === array.length - 1) {
                    date = getCurrentDateWithoutSecondsAndMilliseconds();
                }
                series_placed.push([date, data.placed]);
                series_processed.push([date, data.processed]);
                timezone = data.tz;
            });

            series = [{
                name: _('Placed'),
                data: series_placed,
                type: 'areaspline',
                fillColor: hcFillColor(0)
            }, {
                name: _('Processed'),
                data: series_processed,
                type: 'areaspline',
                fillColor: hcFillColor(1)
            }];
        } else {
            response.data.forEach(function (data, index, array) {
                let date = Date.parse(data.date);
                if (index === array.length - 1) {
                    date = getCurrentDateWithoutSecondsAndMilliseconds();
                }
                series_reserved.push([date, data.reserved]);
                series_placed.push([date, data.placed]);
                series_receipt.push([date, data.receipt]);
                series_prepared.push([date, data.prepared_to_withdrawn]);
                series_extracted.push([date, data.extracted]);
                series_canceled.push([date, data.canceled]);
                series_calls.push([date, data.calls]);
                timezone = data.tz;
            });
            console.log('Timezone:', timezone);
            series = [{
                name: _('Reserved'),
                data: series_reserved,
                type: 'areaspline',
                fillColor: hcFillColor(0)
            }, {
                name: _('Placed'),
                data: series_placed,
                type: 'areaspline',
                fillColor: hcFillColor(1)
            }, {
                name: _('Received'),
                data: series_receipt,
                type: 'areaspline',
                fillColor: hcFillColor(2)
            }, {
                name: _('To withdrawal'),
                data: series_prepared,
                type: 'areaspline',
                fillColor: hcFillColor(3)
            }, {
                name: _('Withdrawn'),
                data: series_extracted,
                type: 'areaspline',
                fillColor: hcFillColor(4)
            }, {
                name: _('Canceled'),
                data: series_canceled,
                type: 'areaspline',
                fillColor: hcFillColor(5)
            }, {
                name: _('Calls'),
                data: series_calls,
                type: 'areaspline',
                fillColor: hcFillColor(6)
            }];
        }

        Highcharts.stockChart('orders-chart', {
            rangeSelector: {
                enabled: false
            },
            navigator: {
                xAxis: {
                    tickInterval:true,
                    labels: {
                        align: 'center'
                }
            }},
            title: null,
            series: series,
            time: {
                useUTC: false,
                timezone: timezone,
            },
        });
    });
}

function initDevicesOrdersPlacedChart(devices=null, start_date=null, end_date=null) {
    let block = $('[data-dashboard="devices-orders-placed-chart"]');
    let report_block = $('[data-congestion-report="devices-orders-placed-chart"]');
    if (block.length === 0) {
        if (report_block.length === 0) {
            return;
        }
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let series_placed = [];
    let avg_series_placed = [];

    let url = '/api/2.0.0/dashboard/devices/orders/placed/period/stat/';

    // add url param: ?devices=1732,2021,7777
    url += (devices === null) ? '' : '?devices=' + devices;
    // add url param: ?start_date=2021-01-01 if it first param else &start_date=2021-01-01
    let start_date_param = (start_date === null) ? '' : 'start_date=' + start_date;
    url += (devices === null) ? '?' + start_date_param : '&' + start_date_param    
    // add url param: ?end_date=2021-01-01 if it first param else &end_date=2021-01-01
    let end_date_param = (end_date === null) ? '' : 'end_date=' + end_date;
    url += (devices === null && start_date == null) ? '?' + end_date_param : '&' + end_date_param
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '&net=' + dashboardNetworkFilter;
    }
    let timezone = "UTC";
    sendApiGet(url, function (response) {
        let placed_sum = response.data.reduce(function (acc, curr) {
            return {
                date: curr.date,
                placed: acc.placed + curr.placed
            }
        });
        let objects_count = response.data.length;
        response.data.forEach(function (data, index, array) {
            let date = Date.parse(data.date);
            if (index === array.length - 1) {
                    date = getCurrentDateWithoutSecondsAndMilliseconds();
                }
            series_placed.push([date, data.placed]);
            avg_series_placed.push([date, placed_sum.placed / objects_count]);
            timezone = data.tz;
        });
        console.log('Timezone:', timezone);
        let series = [{
            name: _('Workload'),
            data: series_placed,
            type: 'areaspline',
            fillColor: hcFillColor(0)
        }, {
            name: _('Avg. Workload'),
            data: avg_series_placed,
            type: 'areaspline',
            fillColor: hcFillColor(0)
        }];

        Highcharts.stockChart('devices-orders-placed-chart', {
            colors: ['#3867d6', '#dc3545'],
            rangeSelector: {
                enabled: false
            },
            navigator: {
                xAxis: {
                    tickInterval:true,
                    labels: {
                        align: 'center'
                }
            }},
            title: null,
            tooltip: {
                valueSuffix: '%',
                valueDecimals: 4
            },
            series: series,
            time: {
                useUTC: false,
                timezone: timezone,
            },
        });
    });
}

function setStatusData(block, current, available, sleep, total, percent) {
    $('[data-current]', block).text(current);
    if (available !== null) {
        $('[data-available]', block).text(available);
    }
    $('[data-total]', block).text(total);
    if (sleep !== null) {
        $('[data-sleep]', block).text(sleep);
    }
    $('[data-progress]', block).css({width: percent + '%'}).attr('aria-valuenow', percent);
    $('[data-percent]', block).text(percent + '%');
}

function initOrdersStats() {
    let block = $('[data-dashboard="orders-stats"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/orders/stats/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        let data = response.data;

        $('[data-total]', block).text(data.orders_total);
        $('[data-month]', block).text(data.orders_month);
        $('[data-day]', block).text(data.orders_day);

        $('[data-percentage-month]', block).text(data.use_percentage_month + '%');
        $('[data-percentage-day]', block).text(data.use_percentage_day + '%');

        // delta not used anymore
        // let delta = data.use_percentage_delta;
        // let delta_class = delta > 0 ? 'text-success' : 'text-danger';
        // let delta_sign = delta > 0 ? '+' : '';
        // $('[data-delta]', block)
        //     .removeClass('text-success text-danger')
        //     .addClass(delta_class)
        //     .text(delta_sign + data.use_percentage_delta + '%');
    });
}

function initOrdersPie() {
    let block = $('[data-dashboard="orders-pie"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/orders/current/date/stat/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        let data = response.data;

        $('[data-current]', block).text(data.total_orders);

        let series = [{
            name: _('Order'),
            colorByPoint: true,
            data: [{
                name: _('Reserved'),
                count: data.reserved,
                y: parseFloat(((data.reserved / data.total_orders) * 100).toFixed(2))
            }, {
                name: _('Placed'),
                count: data.placed,
                y: parseFloat(((data.placed / data.total_orders) * 100).toFixed(2))
            }, {
                name: _('Received'),
                count: data.receipt,
                y: parseFloat(((data.receipt / data.total_orders) * 100).toFixed(2))
            }, {
                name: _('To withdrawal'),
                count: data.prepared_to_withdrawn,
                y: parseFloat(((data.prepared_to_withdrawn / data.total_orders) * 100).toFixed(2))
            }, {
                name: _('Withdrawn'),
                count: data.extracted,
                y: parseFloat(((data.extracted / data.total_orders) * 100).toFixed(2))
            }, {
                name: _('Canceled'),
                count: data.canceled,
                y: parseFloat(((data.canceled / data.total_orders) * 100).toFixed(2))
            }]
        }];

        Highcharts.chart('orders-pie', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: null,
            tooltip: {
                pointFormat: '<b>{point.count}</b> ({point.percentage:.1f}%)'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                itemMarginTop: 3,
                itemMarginBottom: 3
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: series
        });
    });
}

function initTopDevices() {
    let block = $('[data-dashboard^="device-top-"]');
    if (block.length === 0) {
        return;
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/devices/top/10/loaded/orders/stat/';
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '?net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {

        let device_card_length = $('.device-card').length;
        for (var i=0; i < device_card_length - response.data.length; i++) {
            // remove unused cards
            $('.device-card:last').remove();
        }

        response.data.forEach(function (data, i) {
            i = i + 1;
            let block = $('[data-dashboard="device-top-' + i + '"]');
            if (block.length === 0) {
                return;
            }

            let device = $('<a/>').text(data.id).attr('href', '/devices/' + data.id + '/panel/')
            $('[data-id]', block).empty();
            $('[data-id]', block).append(device);
            $('[data-address]', block).text(data.address ? data.address : '-');
            $('[data-stacks]', block).text(data.stacks);
            $('[data-cells]', block).text(data.cells);
            $('[data-load]', block).text(data.load_average + ' %');
        });
    });
}

function initTopReport() {
    let block = $('[data-dashboard^="report-top-"]');
    if (block.length === 0) {
        return;
    }
    let url = '/api/2.0.0/dashboard/devices/top/10/loaded/orders/stat/';
    sendApiGet(url, function (response) {
        response.data.forEach(function (data, i) {
            i = i + 1;
            let block = $('[data-dashboard="device-top-' + i + '"]');

            $('[data-id]', block).text(data.id);
            $('[data-address]', block).text(data.address ? data.address : '-');
            $('[data-stacks]', block).text(data.stacks);
            $('[data-cells]', block).text(data.cells);
            $('[data-load]', block).text(data.load_average);
        });
    });
}